import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { UserProvider } from '../src/Componentes/UserContext';
import Home from '../src/Componentes/Home/index';
import Rotas from './Componentes/Rotas/index';
import Footer from './Componentes/Footer/index';

const App = () => {
  return (
    <UserProvider>
        <Router>
          <div>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/rotas" element={<Rotas />} />
            </Routes>
            <Footer />
          </div>
        </Router>
    </UserProvider>
  );
};

export default App;